// Base functions
document.addEventListener("DOMContentLoaded", function() {
    document.body.classList.remove('no-js');
    document.body.classList.add('loaded');
});

// Image loading
(function() {
    if ('loading' in HTMLImageElement.prototype) {
        var imgs = document.querySelectorAll('img[loading=lazy]');
        
        for (var img of imgs) {
            if (!img.complete) {
                img.classList.add('loading');
                img.addEventListener('load', lazyImageLoad, false);
            }
        }
        function lazyImageLoad(e) {
            e.currentTarget.classList.remove('loading');
            e.currentTarget.classList.add('loaded');
        }   
    }
})();

// Mobile nav show/hide + header scroll
document.addEventListener('DOMContentLoaded', function() {
    const navToggle = document.querySelector('.nav-toggle');
    const navMenu = document.getElementById('mobile-nav');
    const header = document.querySelector('.hdr');

    navToggle.addEventListener('click', function() {
        const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
        navToggle.setAttribute('aria-expanded', !isExpanded);
        navMenu.classList.toggle('nav--visible');
        document.body.classList.toggle('menu-open');
    });

    function checkScroll() {
        // if (window.scrollY >= 300) {
        //   header.setAttribute('data-color', 'invert');
        // } else {
        //   header.removeAttribute('data-color');
        // }
    }
    window.addEventListener('scroll', checkScroll);
});

// Animation on scroll
function initAnimations() {
  const animatedElements = document.querySelectorAll('.animate');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  animatedElements.forEach(element => {
    observer.observe(element);
  });
}

// Call the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', initAnimations);


// Detect if scrolling up or down
(function() {
  let lastScrollTop = 0;
  const body = document.body;
  const scrollThreshold = 5;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (Math.abs(lastScrollTop - scrollTop) <= scrollThreshold) return;

    if (scrollTop > lastScrollTop && scrollTop > 0) {
      body.classList.remove('is-scrolling-up');
      body.classList.add('is-scrolling-down');
    } else {
      body.classList.remove('is-scrolling-down');
      body.classList.add('is-scrolling-up');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('load', () => body.classList.add('is-scrolling-up'));

  handleScroll();
})();

// Change footer text
document.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector('.ftr-text-anim');
  const texts = JSON.parse(element.dataset.texts);
  let index = 0;

  setInterval(() => {
    element.textContent = texts[index];
    element.classList.add('wobble');
    setTimeout(() => element.classList.remove('wobble'), 1000);
    index = (index + 1) % texts.length;
  }, 2000);
});

// Lottie animation handling
function initLottieAnimations() {
  const lottieContainers = document.querySelectorAll('.lottie-container');
  const loadedAnimations = new Map();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const container = entry.target;
      const jsonPath = container.dataset.lottieJson;

      if (entry.isIntersecting) {
        if (!loadedAnimations.has(container)) {
          const animation = lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: jsonPath
          });

          loadedAnimations.set(container, animation);

          animation.addEventListener('DOMLoaded', () => {
            animation.play();
          });
        } else {
          loadedAnimations.get(container).play();
        }
      } else {
        const animation = loadedAnimations.get(container);
        if (animation) {
          animation.pause();
        }
      }
    });
  }, { rootMargin: '100px' });

  lottieContainers.forEach(container => {
    observer.observe(container);
  });
}

// Call the function when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', initLottieAnimations);